import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "../fieldsDictionary";
import { FieldViewType } from "../viewType";
import EmailFieldDetail from "./detail";
import EmailFieldEdit from "./edit";
import EmailFieldList from "./list";
/** <b>Composant qui contient l'affichage d'un champ de type email en: </b>
 *  <li>Liste</li>
 *  <li>Détails</li>
 *  <li>Édition</li>
 */
export function Email() {
    return _jsx(_Fragment, { children: "Email" });
}
var field = fieldsType.email;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, EmailFieldDetail);
fieldsDictionary.registerField(FieldViewType.EDIT, field, EmailFieldEdit);
fieldsDictionary.registerField(FieldViewType.LIST, field, EmailFieldList);
